export default function HeaderStats() {
  return (
    <>
      {/* Header */}
      <div className="relative bg-[#02500999] pt-20 pb-32 ">
        <div className="mx-auto w-full">
        </div>
      </div>
    </>
  );
}
